const data = {
  users: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [
      {
        // fix: true,
        prop: 'siteName',
        label: '站点名称',
        width: '200'
      }, {
        prop: 'siteId',
        label: '站点编号',
        width: '150'
      },
      {
        prop: 'length',
        label: '站点长度',
        width: '120'
      },
      {
        prop: 'recycleSwitch',
        label: '回收站点',
        width: '120'
      }, {
        prop: 'brandPutSwitch',
        label: '可投放',
        width: '200'
      }, {
        prop: 'majorSwitch',
        label: '区域属性',
        width: '200'
      }, {
        prop: 'dispatchThresholdMore',
        label: '偏多阀值',
        width: '200'
      }, {
        prop: 'dispatchThresholdLess',
        label: '偏少阀值',
        width: '200'
      }, {
        prop: 'dispatchResponseMinute',
        label: '调度响应时间',
        width: '200'
      },
      //  {
      //   prop: 'equipmentNo',
      //   label: '道钉编号',
      //   width: '100'
      // },
      //  {
      //   prop: 'equipmentMac',
      //   label: 'MAC地址',
      //   width: '200'
      // }, {
      //   prop: 'equipmentSignal',
      //   label: '信号强度',
      //   width: '120'
      // }, {
      //   prop: 'equipmentPower',
      //   label: '电池电量',
      //   width: '120'
      // }, {
      //   prop: 'updateTime',
      //   label: '更新时间',
      //   width: '200'
      // }, {
      //   prop: 'equipmentOnlineTime',
      //   label: '上线时间',
      //   width: '120'
      // },
      {
        label: '操作',
        width: '200'
      }
    ]
  },
  powerList: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [
      {
        prop: 'power',
        label: '电池电量'
      }, {
        prop: 'type',
        label: '更新方式'
      }, {
        prop: 'createTime',
        label: '更新时间'
      }
    ]
  },
  noStoppingZone: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [
      {
        // fix: true,
        prop: 'index',
        label: '序号',
        width: '100'
      }, {
        prop: 'alias',
        label: '禁停区名称',
        width: '110'
      }, {
        prop: 'serial',
        label: '编号',
        width: '100'
      }, {
        prop: 'updateTime',
        label: '更新时间',
        width: '100'
      }, {
        prop: 'createTime',
        label: '上线时间',
        width: '200'
      }, {
        fix: 'right',
        label: '操作',
        width: '200'
      }
    ]
  },
  forbiddenZone: {
    name: '全部',
    getList: '',
    getDetail: '',
    status: null,
    columns: [
      {
        // fix: true,
        prop: 'index',
        label: '序号',
        width: '100'
      }, {
        prop: 'alias',
        label: '禁行区名称',
        width: '110'
      }, {
        prop: 'serial',
        label: '编号',
        width: '100'
      }, {
        prop: 'updateTime',
        label: '更新时间',
        width: '100'
      }, {
        prop: 'createTime',
        label: '上线时间',
        width: '200'
      }, {
        fix: 'right',
        label: '操作',
        width: '200'
      }
    ]
  }
}

export default data
